'use strict'
export default {
    iconList: [    
        {
            icon: require("../assets/img/icon_Insight_home_default.png"),
            title: "数据洞察",
            info: "这里是对应服务的简单描述，这里是对应服务的简单描述",
            link: 'DataInsight',
            
          },
          {
            icon: require("../assets/img/icon_assessment_home_default.png"),
            title: "房屋智能估价",
            info: "这里是对应服务的简单描述，这里是对应服务的简单描述",
            link: 'Collateral',
          },
          {
            icon: require("../assets/img/icon_project_home_default.png"),
            title: "一键看项目",
            info: "这里是对应服务的简单描述，这里是对应服务的简单描述",
            link: 'ViewItems',
          },
          {
            icon: require("../assets/img/icon_customized_home_default.png"),
            title: "定制化",
            info: "这里是对应服务的简单描述，这里是对应服务的简单描述",
            link: 'Customization',
          },
          // {
          //   icon: require("../assets/img/icon_exchange_home_default.png"),
          //   title: "交易所",
          //   info: "这里是对应服务的简单描述，这里是对应服务的简单描述",
          //   link: 'Exchange',
          // },
    ]
}